;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:pathArray*\",\"regex\":\"^/(.+)$\",\"paramNames\":[\"pathArray\"],\"hasOptionalPrefix\":false},{\"path\":\"/customer/:pathArray*\",\"regex\":\"^/customer/(.+)$\",\"paramNames\":[\"pathArray\"],\"hasOptionalPrefix\":false},{\"path\":\"/swatches/swatch/:fabricName*\",\"regex\":\"^/swatches/swatch/(.+)$\",\"paramNames\":[\"fabricName\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/app-classic\"},{\"path\":\"/app-new\"},{\"path\":\"/swatches\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.0.9";import * as Sentry from '@sentry/nextjs';

import getEnvValue from 'commons/getEnvValue';

// Load public environment variables (populate globalThis._env_)
import './publicEnvConfig';

import sharedSentryConfig from '../sentry.shared-config';
import initDash0WebSdk from './initDash0WebSdk';
import { logInfo } from 'commons/logger';

const isLocal = getEnvValue('NEXT_PUBLIC_ENV_NAME') === 'local';

// Initialize Sentry on the client
// https://docs.sentry.io/platforms/javascript/guides/nextjs/manual-setup/
Sentry.init({
  ...sharedSentryConfig,

  // Proxy envelopes through our server to bypass ad blockers and avoid CORS issues.
  // Only needed locally — in deployed environments Sentry requests go direct.
  ...(isLocal && { tunnel: '/api/sentry-tunnel/' }),

  // Client-specific integrations
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
      mask: ['.sensitive', '[data-sensitive]'],
    }),
    Sentry.browserTracingIntegration({
      enableLongTask: true,
      enableNavigationSpan: true,
    }),
  ],

  // Replay configuration - configurable via environment variables
  replaysSessionSampleRate: parseFloat(
    getEnvValue('SENTRY_REPLAYS_SESSION_SAMPLE_RATE') || '0.02'
  ),
  replaysOnErrorSampleRate: parseFloat(
    getEnvValue('SENTRY_REPLAYS_ERROR_SAMPLE_RATE') || '1.0'
  ),

  // Trace propagation targets - match the same domains as initDash0WebSdk propagators.
  // Exclude third-party analytics subdomains starting with 'gtm' or 'rudr'
  // (e.g. gtm.prod.nest.joybird.com) to prevent CORS errors.
  tracePropagationTargets: [
    /^https:\/\/(?!(?:gtm|rudr)).*\.joybird\.com/,
    /^https?:\/\/.*\.local/,
    /^https?:\/\/localhost/,
    getEnvValue('NEXT_PUBLIC_GRAPHQL_BASE_URL'),
    process.env.PRIVATE_GRAPHQL_BASE_URL,
  ].filter(Boolean),

  // Client-specific error handling
  beforeSend(event, hint) {
    // Call shared beforeSend first
    const filteredEvent = sharedSentryConfig.beforeSend?.(event, hint);
    if (!filteredEvent) return null;

    // Additional client-side filtering
    if (event.exception) {
      const error = hint.originalException;
      if (error?.message) {
        const message = error.message;
        if (
          message.includes('ResizeObserver loop limit exceeded') ||
          message.includes('Non-Error promise rejection')
        ) {
          return null;
        }
      }
    }
    return filteredEvent;
  },
});

const isClientTracingEnabled =
  getEnvValue('NEXT_PUBLIC_CLIENT_TRACING_ENABLED') === 'true';

if (isClientTracingEnabled) {
  logInfo('Initializing Dash0 Web SDK on client');
  initDash0WebSdk();
} else {
  logInfo('Dash0 Web SDK is disabled');
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
